import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

import { map } from "rxjs/operators";

@Injectable()
export class DeliveryDetailsService {
  private single_url = `${environment.API_URL}/delivery-details`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  submit(params) {
    //params["token"] = this.token;
    //console.log(params);
    return this.http
      .post(this.single_url, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        return response;
      });
  }

  checkToken(params) {
    let body = { transport_token: params };
    return this.http
      .post(this.single_url + "/checkToken", body, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        return response;
      });
  }

  updateStatus(token:string, status:string) {
    let body = { transport_token: token, status: status };
    return this.http
      .post(this.single_url + "/updateStatus", body, {
        headers: this.headers,
      })
      .pipe(
        map((res) => {
          let response = JSON.parse(JSON.stringify(res));
          return response;
        })
      );
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/delivery-details.service.ts